import ko from "knockout";

export function makeObservableIfNeeded<T>(obj: T | KnockoutObservable<T>, defaultValue?: T): KnockoutObservable<T> {
    if (ko.isObservable(obj)) {
        return obj;
    } else if (typeof obj === "function") {
        return ko.pureComputed<T>(obj as () => T);
    } else if (obj !== undefined) {
        return ko.observable<T>(obj);
    }
    return ko.observable<T>(defaultValue);
}

export function makeListObservableIfNeeded<T>(
    variable: T[] | KnockoutObservable<T[]> | KnockoutObservableArray<T>,
    defaultValue?: any[]
): KnockoutObservable<T[]> | KnockoutObservableArray<T> {
    if ((ko as any).isObservableArray(variable)) {
        return variable as KnockoutObservableArray<T>;
    } else if (ko.isObservable(variable)) {
        return variable;
    } else if (Array.isArray(variable)) {
        return ko.observableArray(variable);
    } else if (variable === undefined) {
        return ko.observableArray(defaultValue);
    }
    throw Error(`Conversion of type ${typeof variable} to observable array not supported.`);
}

export function makeObservableArrayIfNeeded<T>(
    variable: T[] | KnockoutObservableArray<T>,
    defaultValue?: any[]
): KnockoutObservableArray<T> {
    if ((ko as any).isObservableArray(variable)) {
        return variable as KnockoutObservableArray<T>;
    } else if (Array.isArray(variable)) {
        return ko.observableArray(variable);
    } else if (variable === undefined) {
        return ko.observableArray(defaultValue);
    }
    throw Error(`Conversion of type ${typeof variable} to observable array not supported.`);
}
